"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgem = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 60 47",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgem` : '') + (description ? ` desc-brandedgem` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgem"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgem"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 47 0 15.67h17.7L30 47Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m30 47 30-31.33H41.92L30 47Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.92 15.67H17.7L30 47l11.92-31.33Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.46 0 0 15.67h17.7L13.45 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.7 15.67 30 0l11.92 15.67H17.7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.92 15.67 46.61 0 60 15.67H41.92Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 0H13.46l4.23 15.67L30 0Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 0h16.6l-4.68 15.67L30 0Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m42.95 26.97-.95 1-.95-1a6.33 6.33 0 0 0-10.37 1.74l-.12.26a6.89 6.89 0 0 0 1.13 7.25l9.7 10.51c.33.36.9.36 1.22 0l9.52-10.32a6.87 6.87 0 0 0 1.2-7.7l-.14-.27a6.33 6.33 0 0 0-10.23-1.47Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.03 28.01 42 30.12l-2.04-2.1a4.83 4.83 0 0 0-7.92 1.33l-.1.23a5.4 5.4 0 0 0 .86 5.63l9.2 9.97 9.03-9.8h.02a5.37 5.37 0 0 0 .93-6l-.12-.24a4.83 4.83 0 0 0-7.82-1.13Zm9.16.43.13.27a6.87 6.87 0 0 1-1.2 7.7l-9.5 10.32a.83.83 0 0 1-1.23 0l-9.7-10.51a6.89 6.89 0 0 1-1.13-7.25l.12-.26a6.32 6.32 0 0 1 10.37-1.74l.95 1 .95-1 .1-.09a6.32 6.32 0 0 1 10.14 1.56Z",
    fill: "white"
  }));
};
var _default = exports.default = brandedgem;